const EMPTY_QUILL_VALUES = new Set(["", "<p><br></p>", "<p></p>", "<p><br/></p>"]);

export const stripRichText = (value: string | undefined): string => {
  if (!value) return "";
  return value
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/\s+/g, " ")
    .trim();
};

export const isRichTextEmpty = (value: string | undefined): boolean => {
  if (!value || EMPTY_QUILL_VALUES.has(value.trim())) return true;
  return stripRichText(value) === "";
};
